<template>
  <div>
    <div slot="title">
      <h2>Monitoreo de Asignación de Evaluaciones</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:50px;">
          <div class="col-10">
            <table class="table table-striped table-light table-hover" id="tablaEstadisticasEvaluaciones">
              <thead class="thead-dark">
                <tr>
                  <th colspan="2">Evaluaciones Pendientes de Evaluadores</th>

                  <th colspan="2">Evaluaciones en Proceso</th>
                  <th colspan="2">Evaluaciones Concluidas</th>
                  <th colspan="2">Evaluaciones Entregadas</th>
                </tr>
              </thead>
              <tbody class="text-dark">
                <tr>
                  <td>{{evaluacionesPendientes}} </td>
                  <td><i class="fa fa-info-circle" title="Desplegar Evaluaciones Pendientes" @click="buscarEvaluaciones(2,1,null)"></i></td>
                  <td>{{evaluacionesProceso}}</td>
                  <td><i class="fa fa-info-circle" title="Desplegar Evaluaciones Pendientes" @click="buscarEvaluaciones(2,2,null)"></i></td>
                  <td>{{evaluacionesConcluidas}}</td>
                  <td><i class="fa fa-info-circle" title="Desplegar Evaluaciones Pendientes" @click="buscarEvaluaciones(null,3,0)"></i></td>
                  <td>{{evaluacionesEntregadas}}</td>
                  <td><i class="fa fa-info-circle" title="Desplegar Evaluaciones Pendientes" @click="buscarEvaluaciones(null,3,1)"></i></td>
                </tr>
                <tr>
                  <td>
                    <ul>
                      <li><b>De Base: </b>{{evaluacionesPendientesBase}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li><b>De Confianza: </b>{{evaluacionesPendientesConfianza}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li><b>De Base: </b>{{evaluacionesProcesoBase}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li><b>De Confianza: </b>{{evaluacionesProcesoConfianza}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li><b>De Base: </b>{{evaluacionesConcluidasBase}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li><b>De Confianza: </b>{{evaluacionesConcluidasConfianza}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li><b>De Base: </b>{{evaluacionesEntregadasBase}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li><b>De Confianza: </b>{{evaluacionesEntregadasConfianza}}</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row" style="margin-top:50px;">
          <div class="col-10">
            <table class="table table-striped table-light table-hover" id="tablaEvaluaciones" v-if="mostrarTabla">
              <thead class="thead-dark">
                <tr>
                  <th>
                    Número de Solicitud
                    <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(0,true)' title="Ordenar por Número de Solicitud" /></div>
                    <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(0,false)' title="Ordenar por Número de Solicitud" /></div>
                  </th>
                  <th>Nombre</th>
                  <th>Puesto</th>
                  <th>
                    Departamento
                    <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(3,true)' title="Ordenar por Departamento" /></div>
                    <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(3,false)' title="Ordenar por Departamento" /></div>
                  </th>
                  <th>Tipo Plaza</th>
                  <th>
                    Fecha de Entrega
                    <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(4,true)' title="Ordenar por Fecha de Entrega" /></div>
                    <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(4,false)' title="Ordenar por Fecha de Entrega" /></div>
                  </th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <tr v-for='evaluacion in evaluaciones'>
                  <td>#{{ evaluacion.SolicitudEvaluacionId }}</td>
                  <td>{{evaluacion.nombreEvaluado}}</td>

                  <td>{{evaluacion.Puesto}}</td>
                  <td>{{evaluacion.Seccion}} - {{evaluacion.Departamento}}</td>
                  <td>{{evaluacion.TipoPlaza}}</td>
                  
                  <td>{{evaluacion.FechaLimiteEntregaString}}</td>
                  
                </tr>
                <tr v-if="evaluaciones.length == 0"><td colspan="8">No se encontraron evaluaciones en proceso</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import Vue from 'vue'
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  export default {
    data() {
      return {
        evaluacionesPendientes: null,
        evaluacionesProceso: null,
        evaluacionesConcluidas: null,
        evaluacionesEntregadas: null,
        mostrarTabla: false,
        evaluaciones: []
      }
    },
    components: {
    },
    methods: {
      ConteoEvaluaciones: function () { //Retorna una lista de evaluaciones pendientes en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.RealizarConteoEvaluaciones, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.evaluacionesPendientes = response.data.EvaluacionesPendientes;
            this.evaluacionesPendientesBase = response.data.EvaluacionesPendientesBase;
            this.evaluacionesPendientesConfianza = response.data.EvaluacionesPendientesConfianza;
            this.evaluacionesProceso = response.data.EvaluacionesProceso;
            this.evaluacionesProcesoBase = response.data.EvaluacionesProcesoBase;
            this.evaluacionesProcesoConfianza = response.data.EvaluacionesProcesoConfianza;
            this.evaluacionesConcluidas = response.data.EvaluacionesConcluidas;
            this.evaluacionesConcluidasBase = response.data.EvaluacionesConcluidasBase;
            this.evaluacionesConcluidasConfianza = response.data.EvaluacionesConcluidasConfianza;
            this.evaluacionesEntregadas = response.data.EvaluacionesEntregadas;
            this.evaluacionesEntregadasBase = response.data.EvaluacionesEntregadasBase;
            this.evaluacionesEntregadasConfianza = response.data.EvaluacionesEntregadasConfianza;
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      buscarEvaluaciones: function (estatusSolicitud, EstatusEvaluacion, EntregaPresidencia) { //Retorna una lista de evaluaciones pendientes en base a ciertos filtros
        this.mostrarTabla = true;
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false,
          "nombreEvaluadoBusqueda": '',
          "estatusSolicitud": estatusSolicitud,
          "EstatusEvaluacion": EstatusEvaluacion,
          "EntregaPresidencia": EntregaPresidencia
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetEvaluaciones, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            $("#alertaNumeroNomina").hide();//Oculta la alerta de número de nómina no válido (filtro de busqueda)
            this.evaluaciones = response.data.evaluaciones//Carga los datos necesarios
            this.$nextTick(() => {
              PaginarTabla('tablaEvaluaciones', 100)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      truncator: function (numToTruncate, intDecimalPlaces) {
        var numPower = Math.pow(10, intDecimalPlaces); // "numPowerConverter" might be better
        return ~~(numToTruncate * numPower)/numPower;
      },
      comparar: function (a, b) {
        var SeccionA = 0;
        var SeccionB = 0;
        if (this.columna == 0) {
          SeccionA = a.SolicitudEvaluacionId;
          SeccionB = b.SolicitudEvaluacionId;
        } else if (this.columna == 3) {
          SeccionA = a.Seccion.toUpperCase();
          SeccionB = b.Seccion.toUpperCase();
        } else if (this.columna == 4) {
          var from = a.FechaLimiteEntregaString.split("/");
          SeccionA = new Date(from[2], from[1] - 1, from[0]);
          from = b.FechaLimiteEntregaString.split("/");
          SeccionB = new Date(from[2], from[1] - 1, from[0]);
        } else {
          return 0;
        }
        if (!this.sentido) {
          var aux;
          aux = SeccionA;
          SeccionA = SeccionB;
          SeccionB = aux;
        }
        let comparison = 0;
        if (SeccionA > SeccionB) {
          comparison = 1;
        } else if (SeccionA < SeccionB) {
          comparison = -1;
        }
        
        return comparison;
      },
      ordenar: function (columna, sentido) {
        this.columna = columna
        this.sentido = sentido
        this.evaluaciones.sort(this.comparar);
        this.$nextTick(() => {
              PaginarTabla('tablaEvaluaciones', 100)
            })
      }
    }, mounted: function mounted() {//Al cargarse la vista hace la busqueda de evaluaciones sin filtros
      this.ConteoEvaluaciones();
    }
  }




</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/MonitoreoAsignacionEvaluaciones.vue